export const companyNameToDomainName = (companyName: string): string =>
  companyName.toLowerCase().split(' ').join('-');
